export const HOTLINE_CHATBOT_MODAL_TRIGGER_ID = "hotline-chatbot-modal-trigger";
export const HOTLINE_CHATBOT_MODAL_TRIGGER_ID = "hotline-chatbot-modal-trigger";
